module.exports = __webpack_public_path__ + "img/updatepanel-exit.c260a661.gif";